module.exports = __webpack_public_path__ + "img/google-logo-icon-sign-in.e8e245c9.svg";